export default __webpack_public_path__ + "static/media/uy.a5f5d4b5.svg";